'use strict';

exports.__esModule = true;
//  weak

var ENTER = exports.ENTER = 'ENTER';
var UPDATE = exports.UPDATE = 'UPDATE';
var LEAVE = exports.LEAVE = 'LEAVE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-move/core/types.js
// module id = 306
// module chunks = 0